// src/components/validate.js (adjust path as needed)
import i18next from 'i18next';
import { object, string } from 'yup';

export default () => {
    return object().shape({
        new_password: string()
            .required(i18next.t('Password cannot be empty'))
            .min(8, i18next.t('Password must be at least 8 characters')) // Optional enhancement
            .nullable(),
        confirm_password: string()
            .required(i18next.t('Confirm password cannot be empty'))
            .test(
                'passwords-match',
                i18next.t('Confirm password does not match'),
                function (value) {
                    return this.parent.new_password === value;
                },
            )
            .nullable(),
    });
};
